import { Shopify } from "@models/shopify.model";

export const getOrderVariantTitle = (
  title: string,
  variant: Shopify.OrderItemVariant,
  isBundle: boolean = false
) => {
  if (!isBundle && variant?.title && variant.title !== "Default Title" && variant.title !== title) {
    return variant.title;
  }

  return null;
};
